import { Appointment, checkAppointment } from "./ClassDefinitions";
import { getPatient } from '../firebase_files/patient_functions'

/**
 * Validates user input and alerts the user in hopes they change their foolish ways
 * @param {Appointment} apt 
 * @returns {boolean} Whether the input is valid
 */
export function validateUserInput(apt: Appointment) {
    const result = checkAppointment(apt);
    if (!result.success) {
        alert(result.errorMessage);
        return false;
    }
    return true;
}

export function convertCodeStringToArray(codeString: string) {
    for (const c of codeString) {
        console.log(/^[a-z0-9 ,]+$/i.test(c))
    }
}
/**
 * CHAT GPT METHOD
 * Converts an array of strings into a comma-delimited string, with commas between each element except the last one.
 * @param {Array} array - The input array of strings.
 * @returns {string} - The comma-delimited string representation of the array elements.
 */
export function convertToStringWithCommas(array: Array<string>) {
    if (!Array.isArray(array)) {
        return '';
    }

    if (array.length === 0) {
        return '';
    }

    if (array.length === 1) {
        return array[0];
    }

    return array.slice(0, -1).join(', ') + ', ' + array[array.length - 1];
}

/**
 * @param {Date} onDate - optional, defaults to todays date
 * @returns {number} - Unix time stamp of midnight
 */
export function getTimeAtMidnight(onDate) {
    onDate = onDate || new Date();
    onDate.setHours(0, 0, 0, 0); // set to midnight
    const unixTimeStamp: number = onDate.getTime(); // 
    return unixTimeStamp;
}

/**
 * @param patientId 
 * @returns {string} name of patient 
 */
export async function getPatientNameWithId(patientId: string){
    let patient: any = await getPatient(patientId); 
    return patient.name;
}

/**
 * Returns the number of days between two Dates
 * @param {Date} d1 
 * @param {Date} d2 
 * @return {Number} days
 */

export function daysBetween(d1, d2) {
    return Math.abs(d2.getTime() - d1.getTime()) / 86400000
}

export function format$(val) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    return formatter.format(val);
  }

  /**
 * Returns the date formatted for date input elements
 * @param { Date } dt 
 * @return { String } yyyy-MM-dd
 */
  export function dateString(dt) {
    let y = dt.getFullYear();
    let m = dt.getMonth() + 1; // zero based
    if (m < 10) m = '0' + m;
    let d = dt.getDate();
    if (d < 10) d = '0' + d;
    return y + '-' + m + '-' + d;
  }

  export function calculateAge(dob, atDate) {
    atDate = atDate || Date.now();
    var diff_ms = atDate - dob.getTime();
    var age_dt = new Date(diff_ms);
    return Math.abs(age_dt.getUTCFullYear() - 1970);
}
